import { myApi } from "./api";
import {
  createOrderOther,
  createOrderMarket,
  cancelOrder,
  closePositions,
  getSymbols,
} from "../components/constant/Api";

export const exchangeUniApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (post) => ({
        url: createOrderOther,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.success ? response ?? response : response;
      },
    }),
    createOrderMarket: builder.mutation({
      query: (post) => ({
        url: createOrderMarket,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.success ? response ?? response : response;
      },
    }),
    modifyPositions: builder.mutation({
      query: (post) => ({
        url: "/modify-position",
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.success ? response ?? response : response;
      },
    }),
    cancelOrder: builder.mutation({
      query: (post) => ({
        url: cancelOrder,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.success ? response ?? response : response;
      },
    }),
    closePositions: builder.mutation({
      query: (post) => ({
        url: "/close-position",
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.success ? response ?? response : response;
      },
    }),
    getUserOrders: builder.query({
      query: (user_id) => ({
        url: `/user-orders/${user_id}`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getUserPositions: builder.query({
      query: (user_id) => ({
        url: `/user-positions/${user_id}`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    closeTradesPnl: builder.query({
      query: (user_id) => ({
        url: `/user-close-pnl/${user_id}`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getBalance: builder.query({
      query: (user_id) => ({
        url: `/balance-user/${user_id}`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getSymbols: builder.query({
      query: ({ segment }) => ({
        url: `${getSymbols}/${segment}`,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? "" : "";
      },
    }),
    getAllOrders: builder.query({
      query: (userId) => ({ url: `/user/${userId}/orders`, method: "GET" }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getWorkingOrders: builder.query({
      query: (userId) => ({
        url: `/user/${userId}/working`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getCancelledOrders: builder.query({
      query: (userId) => ({
        url: `/user/${userId}/cancelled`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getClosedPositions: builder.query({
      query: (userId) => ({
        url: `/user/${userId}/closed`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
    getUserNotifications: builder.query({
      query: (user_id) => ({
        url: `/user-notifications/${user_id}`,
        method: "GET",
      }),
      transformResponse: (res) => (res.success ? res.data : []),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useCreateOrderMarketMutation,
  useGetUserOrdersQuery,
  useGetUserPositionsQuery,
  useGetBalanceQuery,
  useClosePositionsMutation,
  useCloseTradesPnlQuery,
  useGetAllOrdersQuery,
  useGetCancelledOrdersQuery,
  useGetClosedPositionsQuery,
  useGetWorkingOrdersQuery,
  useCancelOrderMutation,
  useModifyPositionsMutation,
  useGetUserNotificationsQuery,
} = exchangeUniApi;
